import React from 'react';
import { Box, Typography } from '@mui/material';

const NoDataMessage = ({ message = '' }) => {
  return (
    <Box height="inherit" display="flex" alignItems="center" justifyContent="center">
      <Typography variant="caption" sx={{ color: (theme) => theme.palette.grey[600] }}>
        {message}
      </Typography>
    </Box>
  );
};

export default NoDataMessage;
